module.exports = __webpack_public_path__ + "static/img/化妆品.63f12d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/化妆品.png
// module id = UeVS
// module chunks = 13